<template>
  <div class="content-box">
    <div class="content-body">
      <el-breadcrumb style="padding-top: 30px" separator="/">
        <el-breadcrumb-item :to="{ path: '/help/ticket/list' }">问题反馈</el-breadcrumb-item>
        <el-breadcrumb-item>问题详情</el-breadcrumb-item>
      </el-breadcrumb>

      <div v-if="ticket !== null" style="padding-top: 30px">
        <div style="padding-bottom: 15px">
          <span style="font-size: 24px;font-weight: 900;color: #424456; padding-right: 5px">{{ ticket.title }}</span>
          <el-tag size="small">{{ this.$config.ticketTagMap[this.ticket.tag].label }}</el-tag>
          <el-tag size="small" type="warning">{{ this.$config.ticketTypeMap[this.ticket.type].label }}</el-tag>
          <el-tag size="small" v-if="this.ticket.status === 1">待回答</el-tag>
          <el-tag size="small" v-if="this.ticket.status === 2" type="info">已结束</el-tag>
          <el-tag size="small" v-if="this.ticket.status === 3" type="success">已回答</el-tag>
        </div>
        <el-table v-if="this.ticket.tag === 2 && this.ticket.app_key !== undefined"
                  :data=bugs
                  border>
          <el-table-column width=120px; label="环境">
            <template slot-scope="scope">
              <label> {{ getEnvStr(scope.row.env) }}</label>
            </template>
          </el-table-column>
          <el-table-column label="AppKey" prop="app_key">
          </el-table-column>
          <el-table-column label="Signature" prop="signature">
          </el-table-column>
        </el-table>
        <div style="margin-top: 15px" class="block">
          <el-timeline>
            <el-timeline-item v-for="content in this.ticket.contents"
                              :timestamp="getTimeStampStr(content)"
                              :color="getColor(content.contentType)"
                              placement="top" size="large" style="font-size: 14px">
              <el-card style="margin-top: 5px">
                <div v-if="canEdit(content)" style="display: inline-block; float: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit" plain round @click="modifyAction(content)">修改</el-button>
                </div>
                <div style="font-size: 16px; margin-top: 10px; word-wrap:break-word;">{{ content.content }}</div>
                <div class="block" style="margin-top: 10px">
                  <el-image v-for="image in content.images"
                            style="width: 100px; height: 100px; margin-right: 5px; border-radius: 4px;"
                            :src="image.url"
                            :preview-src-list="content.images.map(ans => ans.url)"
                            :fit="'cover'"></el-image>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div style="margin-top: 15px; padding-bottom: 30px">
          <el-button type="primary" plain
                     v-for="action in actions()"
                     @click="action.action">
            {{ action.label }}
          </el-button>
        </div>
      </div>
      <el-dialog style="margin-left:400px; width: 1000px" :visible.sync=showEditDialog
                 :title="editInfo.title">
        <el-input type="textarea" :rows="6"
                  v-model="editInfo.content"
                  placeholder="请输入内容"
                  maxlength="500" style="width: 457px;"
                  show-word-limit
                  clearable></el-input>
        <div class="block" style="margin-top: 15px; margin-bottom: 10px">

          <el-upload
              action="/ajax/common/interface/image/upload"
              accept="image/png, image/jpeg, image/jpg"
              name="image"
              multiple
              :headers="headerData"
              list-type="picture-card"
              :limit="5"
              :file-list="fileList"
              :before-upload="beforeUploadPicture"
              :on-progress="uploadProgress"
              :on-preview="preview"
              :on-remove="remove"
              :on-success="uploadSuccess"
              :on-exceed="handleExceed"
              :show-file-list="true">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <el-button type="primary" style="width: 100%" @click="submit">提交</el-button>
      </el-dialog>
      <el-dialog :visible.sync="imgVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "ticketDetail",
  data() {
    return {
      ticketNo: '',
      ticket: null,
      headerData: {
        Authorization: localStorage.getItem('token')
      },
      fileList: [],
      uploadComplete: true,
      imgVisible: false, // 上传图片预览
      dialogImageUrl: '', // 图片预览地址
      bugs: [1],
      ticketObj: {
        allow_qa: false,
        can_urge: false,
        contents: [{
          id: '',
          contentType: 2,
          content: '',
          account: '',
          images: [],
          updated: ''
        }]
      },
      showEditDialog: false,
      editInfo: {
        title: '',
        content: '',
        contentType: 0, // 值定义见config中的 ticketContentType
        images: []
      },
    }
  },
  mounted() {
    this.ticketNo = this.$route.params.ticketNo;
    this.getDetail();
  },
  computed: {},
  methods: {
    canEdit(content) {
      if (this.ticket.status !== 1) { // 1=待处理
        return false;
      }
      if (content.contentType === 0) { // 问题
        return this.ticket.contents.length === 1;
      }
      // 追问
      return content.contentType === 1 ;
    },
    closeTicket() {
      // 关闭工单
      this.$confirm('确认关闭工单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.isLoading) {
          return;
        }
        this.showCommonLoading();
        this.$axios.post('/ajax/ticket/close', {
          ticketNo: this.ticketNo
        }).then(res => {
          this.hideCommonLoading();
          if (res.data.ret === 0) {
            this.$message.success("工单已关闭");
            this.getDetail();
          }
        }).catch(e => {
          this.hideCommonLoading();
        })
      });
    },
    urgeTicket() {
      if (this.ticket.is_urgent) {
        this.$message.success("催促成功");
        return;
      }
      // 催促工单
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.$axios.post('/ajax/ticket/urge', {
        ticketNo: this.ticketNo
      }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.$message.success("催促成功");
        }
      }).catch(e => {
        this.hideCommonLoading();
        this.$message.error("催促失败");
      });
    },

    submit() {
      if (this.editInfo.content === undefined || this.editInfo.content === null || this.editInfo.content.length === 0) {
        this.$message.error("请输入内容");
      }
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.editInfo.ticketNo = this.ticketNo;
      this.$axios.post('/ajax/ticket/modify', this.editInfo).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.showEditDialog = false;
          this.$message.success("操作成功");
          this.getDetail();
        }
      }).catch(e => {
        this.$message.error("操作失败");
        this.hideCommonLoading();
      })
    },

    modifyAction(content) {
      this.editInfo = content;
      this.editInfo.title = '修改';
      this.fileList = this.editInfo.images;
      this.showEditDialog = true;
    },

    qaAction() {
      this.editInfo.contentType = 1;
      this.editInfo.title = '追问';
      this.showEditDialog = true;
    },
    actions() {
      let qaAction = {
        label: '追问',
        action: this.qaAction,
      }
      let closeAction = {
        label: '关闭工单',
        action: this.closeTicket,
      }
      let urgeAction = {
        label: '催促工单',
        action: this.urgeTicket,
      }
      let actions = [];
      if (this.ticket.allow_qa) {
        actions.push(qaAction);
      }
      // 未关闭工单 可以关闭
      if (this.ticket.status !== 2) {
        actions.push(closeAction);
      }
      if (this.ticket.can_urge) {
        actions.push(urgeAction);
      }

      return actions;
    },
    getColor(type) {
      if (type === 2) {
        return '#0bbd87'
      } else {
        return '#F16222'
      }
    },
    getTimeStampStr(content) {
      let str = `${content.account} ${content.updated} `;
      if (content.contentType === 0) {
        str += '创建';
      } else if (content.contentType === 1) {
        str += '追问';
      } else if (content.contentType === 2) {
        str += '回答';
      }
      return str;
    },
    getEnvStr(env) {
      return this.$config.envDesc[env];
    },
    getDetail() {
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.$axios.post('/ajax/ticket/info', {
        id: this.ticketNo
      }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.ticket = res.data.data;
          this.bugs = [this.ticket];
        }
      }).catch(e => {
          this.hideCommonLoading();
      });
    },
    preview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },
    remove(file, fileList) {
      this.fileChanged(fileList);
    },
    uploadProgress(event, file, fileList) {
      this.uploadComplete = false;
    },
    beforeUploadPicture(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("上传图片不能大于2M");
        return false;
      }
    },
    uploadSuccess(res, file, fileList) {
      this.uploadComplete = true;
      this.fileChanged(fileList);
    },

    fileChanged(fileList) {
      this.fileList = fileList;
      this.editInfo.images = [];
      this.fileList.forEach(file => {
        let response = file.response;
        let url = file.url;
        if (response !== undefined) {
          url = response.data;
        }
        this.editInfo.images.push({'name': file.name, 'url': url});
      });
    },

    handleExceed() {
      this.$message.warning("最多上传5张图片")
    },
  }
}
</script>

<style lang="scss" scoped>
.content-box {
  position: center;
  width: 50%;
  min-width: 1000px;
  margin: 50px auto;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  min-height: 500px;
}

.content-body {
  padding: 0 50px 0 40px;
}

/deep/ .el-timeline-item__timestamp.is-top {
  font-size: 15px;
  padding-top: -3px;
}

.highlight-submit-btn {
  background: #F16622;
  color: #fff;
  margin-top: 20px;
  border: none;
}

/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
}

/deep/ .el-upload {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/ .avatar {
  width: 80px;
  height: 80px;
}

</style>


// WEBPACK FOOTER //
// src/components/ticket/detail.vue